import { Tag } from 'lib/generated/graphql';
import { useState } from 'react';

const TagsSelector = ({
  tags,
  onChange,
  initialValues = [],
}: {
  tags: Tag[];
  onChange: (values: any) => void;
  initialValues?: number[];
}) => {
  const [selectedIds, setSelectedIds] = useState<number[]>(initialValues);

  const selectTag = (tagId: number) => {
    let newTags;

    if (selectedIds.includes(tagId)) {
      newTags = selectedIds.filter((selectedId: number) => selectedId !== tagId);
    } else {
      newTags = [...selectedIds, tagId];
    }

    setSelectedIds(newTags);
    onChange(newTags);
  };

  return (
    <>
      <ul role="list" className="grid grid-cols-1 gap-3 sm:grid-cols-2 mb-5 h-[250px] overflow-auto">
        {tags.map(tag => (
          <li
            data-testid={`tag-${tag.id}`}
            onClick={() => selectTag(tag.id)}
            key={tag.id}
            className={`select-none col-span-1 flex flex-col text-center rounded-md border cursor-pointer py-2 font-medium text-gray-400 ${
              selectedIds.includes(tag.id) ? 'bg-gray-100' : 'bg-white'
            }`}
          >
            {tag.value}
            {selectedIds.includes(tag.id) && <>&nbsp;✔️</>}
          </li>
        ))}
      </ul>
    </>
  );
};

export default TagsSelector;
